const state = {
    fields: {},
    relationshipFields: {},
  }
  
  const getters = {
    fields: state => state.fields,
    relationshipFields: state => state.relationshipFields,
  }
  
  const actions = {
    async init({ commit }, fields) {
      commit('INIT', fields)
    },
    async reset({ commit }) {
      commit('RESET')
    },
    async initRelationship({ commit }, relationshipFields) {
      commit('INIT_RELATIONSHIP', relationshipFields)
    },
    async resetRelationship({ commit }) {
      commit('RESET_RELATIONSHIP')
    }
  }
  
  const mutations = {
    INIT: (state, fields) => {
      state.fields = fields
    },
    RESET: state => {
      state.fields = {}
    },
    INIT_RELATIONSHIP: (state, relationshipFields) => {
      state.relationshipFields = relationshipFields
    },
    RESET_RELATIONSHIP: state => {
      state.relationshipFields = {}
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  